function _assert_this_initialized(self1) {
    if (self1 === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self1;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self1, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self1);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { OpenMeasurement } from '@sky-uk-ott/core-video-sdk-js-external-open-measurement';
import { CoreVideoInternal } from '../../../core-video-internal';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { sdkLogger } from '../../../logger';
import { JsonUtils } from '../../../utils/json-utils';
import { ReportingAddon } from '../reporting-addon';
import { AccessMode, CreativeType, ImpressionType, InteractionType, VideoPlayerState } from './open-measurement-types';
import { cloneAdBreakArray } from '../../../utils/ad-break-utils';
// The partner ID assigned by IAB Tech Lab
export var OpenMeasurementAddon = /*#__PURE__*/ function(ReportingAddon) {
    "use strict";
    _inherits(OpenMeasurementAddon, ReportingAddon);
    function OpenMeasurementAddon(config, session, reportingData) {
        _class_call_check(this, OpenMeasurementAddon);
        var _this;
        _this = _call_super(this, OpenMeasurementAddon), _define_property(_this, "config", void 0), _define_property(_this, "session", void 0), _define_property(_this, "reportingData", void 0), _define_property(_this, "name", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "partnerVersion", void 0), _define_property(_this, "openMeasurementServiceWindow", void 0), _define_property(_this, "videoElement", void 0), _define_property(_this, "allowedVerificationScripts", void 0), _define_property(_this, "serviceScriptTag", void 0), _define_property(_this, "contentUrl", void 0), _define_property(_this, "lastAdPosition", void 0), _define_property(_this, "isDebugMode", void 0), _define_property(_this, "lastSessionState", void 0), _define_property(_this, "omidSessionClient", void 0), _define_property(_this, "partner", void 0), _define_property(_this, "context", void 0), _define_property(_this, "adSession", void 0), _define_property(_this, "adEvents", void 0), _define_property(_this, "mediaEvents", void 0), _define_property(_this, "intersectionChangesCallback", void 0), _this.config = config, _this.session = session, _this.reportingData = reportingData, _this.name = 'openMeasurement', _this.logger = sdkLogger.withContext('OpenMeasurement'), _this.partnerVersion = CoreVideoInternal.version, _this.openMeasurementServiceWindow = self.top, _this.videoElement = undefined, _this.allowedVerificationScripts = [], _this.serviceScriptTag = null, _this.contentUrl = undefined, _this.lastAdPosition = -1, _this.isDebugMode = false, _this.lastSessionState = null, _this.omidSessionClient = OpenMeasurement.OmidSessionClient, _this.partner = undefined, _this.context = new Map(), _this.adSession = undefined, _this.adEvents = undefined, _this.mediaEvents = undefined, _this.intersectionChangesCallback = function(entries) {
            var _entries_;
            if (_this.blockEventsIfNoAdSessionAvailable() || ((_entries_ = entries[0]) === null || _entries_ === void 0 ? void 0 : _entries_.isIntersecting)) {
                return;
            }
            _this.mediaEvents.playerStateChange(VideoPlayerState.MINIMIZED);
        };
        if (CoreVideoInternal.deviceType !== DeviceType.Browser) {
            _this.logger.verbose('Open Measurement is only implemented for Web, addon will be destroyed');
            _this.destroy();
            return _possible_constructor_return(_this);
        }
        _this.isDebugMode = !!_this.config.isDebug;
        _this.partner = new _this.omidSessionClient.Partner(_this.config.partnerName, _this.partnerVersion);
        var _this_reportingData_contentUrl;
        _this.contentUrl = (_this_reportingData_contentUrl = _this.reportingData.contentUrl) !== null && _this_reportingData_contentUrl !== void 0 ? _this_reportingData_contentUrl : self.location.hostname;
        _this.addOpenMeasurementServiceScriptTag();
        _this.listenToPlayerEvents();
        _this.listenToAdEvents();
        return _this;
    }
    _create_class(OpenMeasurementAddon, [
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                this.omidSessionClient = null;
                this.openMeasurementServiceWindow = null;
                this.videoElement = undefined;
                this.partner = undefined;
                this.context = new Map();
                if (this.adSession) {
                    this.adSession.finish();
                    setTimeout(function() {
                        var // OM recommendation to unload script 3s after final finish of active session
                        _this_serviceScriptTag_parentNode, _this_serviceScriptTag;
                        (_this_serviceScriptTag = _this.serviceScriptTag) === null || _this_serviceScriptTag === void 0 ? void 0 : (_this_serviceScriptTag_parentNode = _this_serviceScriptTag.parentNode) === null || _this_serviceScriptTag_parentNode === void 0 ? void 0 : _this_serviceScriptTag_parentNode.removeChild(_this.serviceScriptTag);
                        _this.serviceScriptTag = null;
                    }, 3000);
                } else {
                    var _this_serviceScriptTag_parentNode, _this_serviceScriptTag;
                    (_this_serviceScriptTag = this.serviceScriptTag) === null || _this_serviceScriptTag === void 0 ? void 0 : (_this_serviceScriptTag_parentNode = _this_serviceScriptTag.parentNode) === null || _this_serviceScriptTag_parentNode === void 0 ? void 0 : _this_serviceScriptTag_parentNode.removeChild(this.serviceScriptTag);
                    this.serviceScriptTag = null;
                }
                this.lastAdPosition = -1;
                this.adSession = undefined;
                this.adEvents = undefined;
                this.mediaEvents = undefined;
                this.logger.verbose('Addon destroyed');
            }
        },
        {
            key: "setupAdvertising",
            value: function setupAdvertising(data) {
                var _data_vac;
                this.allowedVerificationScripts = (_data_vac = data.vac) === null || _data_vac === void 0 ? void 0 : _data_vac.omallows;
                this.logger.verbose('Added allowed verification scripts');
            }
        },
        {
            key: "listenToPlayerEvents",
            value: function listenToPlayerEvents() {
                var _this = this;
                this.logger.verbose('Listening to player events');
                this.session.onVideoElementCreated(function(videoElement) {
                    return _this.handleVideoElementCreated(videoElement);
                });
                this.session.onFullscreenChanged(function(isFullscreen) {
                    return _this.handleFullscreenChanged(isFullscreen);
                });
                this.session.onClicked(function() {
                    return _this.handleClicked();
                });
                this.session.onVolumeChanged(function(volume) {
                    return _this.handleVolumeChanged(volume);
                });
                this.session.onMuteChanged(function(isMuted) {
                    return _this.handleMuteChanged(isMuted);
                });
                this.session.onStateChanged(function(state) {
                    return _this.handleStateChanged(state);
                });
            }
        },
        {
            key: "listenToAdEvents",
            value: function listenToAdEvents() {
                this.logger.verbose('Listening to ad events');
                this.listenForAdBreakDataReceivedEvents();
                this.listenForAdStartedEvents();
                this.listenForAdPositionChangedEvents();
                this.listenForAdFinishedEvents();
            }
        },
        {
            key: "listenForAdStartedEvents",
            value: function listenForAdStartedEvents() {
                var _this = this;
                this.session.onAdStarted(function(ad) {
                    var context = _this.context.get(ad.id);
                    if (!context) {
                        _this.logger.warn('No context available for current ad');
                        return;
                    }
                    var adVideoElement = ad.videoElement || _this.videoElement;
                    if (!adVideoElement) {
                        _this.logger.warn('No video element, unable to create ad session context');
                        return;
                    }
                    _this.handleVideoElementCreated(adVideoElement);
                    context.setVideoElement(adVideoElement);
                    _this.adSession = new _this.omidSessionClient.AdSession(context);
                    _this.adSession.setCreativeType(CreativeType.VIDEO);
                    _this.adSession.setImpressionType(ImpressionType.BEGIN_TO_RENDER);
                    if (!_this.adSession.isSupported()) {
                        return;
                    }
                    _this.adSession.start();
                    _this.adEvents = new _this.omidSessionClient.AdEvents(_this.adSession);
                    _this.mediaEvents = new _this.omidSessionClient.MediaEvents(_this.adSession);
                    var adPosition = ad.adBreakType;
                    if (adPosition) {
                        var vastProperties = new _this.omidSessionClient.VastProperties(/* isSkippable= */ false, /* skipOffset= */ 0, /* isAutoPlay= */ true, adPosition);
                        _this.adEvents.loaded(vastProperties);
                    }
                });
            }
        },
        {
            key: "listenForAdFinishedEvents",
            value: function listenForAdFinishedEvents() {
                var _this = this;
                this.session.onAdFinished(function(ad) {
                    if (_this.blockEventsIfNoAdSessionAvailable()) {
                        return;
                    }
                    _this.mediaEvents.complete();
                    _this.adSession.finish();
                    _this.lastAdPosition = -1;
                    _this.adSession = undefined;
                    _this.adEvents = undefined;
                    _this.mediaEvents = undefined;
                });
            }
        },
        {
            key: "listenForAdPositionChangedEvents",
            value: function listenForAdPositionChangedEvents() {
                var _this = this;
                this.session.onAdPositionChanged(function(adPosition) {
                    if (_this.blockEventsIfNoAdSessionAvailable()) {
                        return;
                    }
                    if (adPosition.ad) {
                        var position = adPosition.adPosition;
                        var currentAdPosition = position / adPosition.ad.expectedDuration;
                        var videoElement = _this.videoElement;
                        if (_this.lastAdPosition < 0 && currentAdPosition >= 0) {
                            _this.adEvents.impressionOccurred();
                            _this.mediaEvents.start(adPosition.ad.expectedDuration, videoElement.muted ? 0 : videoElement.volume);
                        } else if (_this.lastAdPosition < 0.25 && currentAdPosition >= 0.25) {
                            _this.mediaEvents.firstQuartile();
                        } else if (_this.lastAdPosition < 0.5 && currentAdPosition >= 0.5) {
                            _this.mediaEvents.midpoint();
                        } else if (_this.lastAdPosition < 0.75 && currentAdPosition >= 0.75) {
                            _this.mediaEvents.thirdQuartile();
                        }
                        _this.lastAdPosition = currentAdPosition;
                    }
                });
            }
        },
        {
            key: "listenForAdBreakDataReceivedEvents",
            value: function listenForAdBreakDataReceivedEvents() {
                var _this = this;
                this.session.onAdBreakDataReceived(function(adBreaks) {
                    var filteredAdBreaks = _this.filterOutNotAllowedVerificationScripts(adBreaks);
                    filteredAdBreaks.forEach(function(adBreak) {
                        adBreak.ads.forEach(function(ad) {
                            _this.createAdSessionContext(ad);
                        });
                    });
                });
            }
        },
        {
            key: "filterOutNotAllowedVerificationScripts",
            value: function filterOutNotAllowedVerificationScripts(adBreaks) {
                var _this = this;
                adBreaks = cloneAdBreakArray(adBreaks);
                adBreaks.forEach(function(adBreak) {
                    var ads = adBreak.ads.map(function(ad) {
                        var _ad_verifications;
                        var verifications = (_ad_verifications = ad.verifications) === null || _ad_verifications === void 0 ? void 0 : _ad_verifications.map(function(verification) {
                            var javaScriptResource = verification.javaScriptResource.filter(function(jsResource) {
                                var _this_allowedVerificationScripts;
                                return !!((_this_allowedVerificationScripts = _this.allowedVerificationScripts) === null || _this_allowedVerificationScripts === void 0 ? void 0 : _this_allowedVerificationScripts.find(function(allowedVerificationScript) {
                                    return allowedVerificationScript.scriptURL === jsResource.uri;
                                }));
                            });
                            return _object_spread_props(_object_spread({}, verification), {
                                javaScriptResource: javaScriptResource
                            });
                        });
                        return _object_spread_props(_object_spread({}, ad), {
                            verifications: verifications
                        });
                    });
                    adBreak.ads = ads;
                });
                return adBreaks;
            }
        },
        {
            key: "handleVideoElementCreated",
            value: function handleVideoElementCreated(videoElement) {
                this.videoElement = videoElement;
                this.logger.info('New video element created');
                this.handleIntersectionChanges(videoElement);
            }
        },
        {
            key: "handleClicked",
            value: function handleClicked() {
                if (this.blockEventsIfNoAdSessionAvailable()) {
                    return;
                }
                this.mediaEvents.adUserInteraction(InteractionType.CLICK);
            }
        },
        {
            key: "handleVolumeChanged",
            value: function handleVolumeChanged(volume) {
                if (this.blockEventsIfNoAdSessionAvailable()) {
                    return;
                }
                this.mediaEvents.volumeChange(volume);
            }
        },
        {
            key: "handleMuteChanged",
            value: function handleMuteChanged(isMuted) {
                if (this.blockEventsIfNoAdSessionAvailable()) {
                    return;
                }
                this.mediaEvents.volumeChange(isMuted ? 0 : this.videoElement.volume);
            }
        },
        {
            key: "handleFullscreenChanged",
            value: function handleFullscreenChanged(isFullscreen) {
                if (this.blockEventsIfNoAdSessionAvailable()) {
                    return;
                }
                var playerState = isFullscreen ? VideoPlayerState.FULLSCREEN : VideoPlayerState.NORMAL;
                this.mediaEvents.playerStateChange(playerState);
            }
        },
        {
            key: "handleIntersectionChanges",
            value: function handleIntersectionChanges(videoElement) {
                var observer = new IntersectionObserver(this.intersectionChangesCallback);
                observer.observe(videoElement);
            }
        },
        {
            key: "handleStateChanged",
            value: function handleStateChanged(state) {
                if (this.blockEventsIfNoAdSessionAvailable()) {
                    return;
                }
                if (state === InternalSessionState.Paused) {
                    this.mediaEvents.pause();
                }
                if (state === InternalSessionState.Playing && this.lastSessionState === InternalSessionState.Paused) {
                    this.mediaEvents.resume();
                }
                this.lastSessionState = state;
            }
        },
        {
            key: "createAdSessionContext",
            value: function createAdSessionContext(ad) {
                var _this = this;
                var _ad_verifications;
                if (!this.openMeasurementServiceWindow) {
                    this.logger.warn('Open Measurement Service Script not available, unable to create ad session context');
                    return;
                }
                var resources = [];
                var accessMode = AccessMode.FULL;
                var adId = ad.id;
                (_ad_verifications = ad.verifications) === null || _ad_verifications === void 0 ? void 0 : _ad_verifications.forEach(function(verification) {
                    verification.javaScriptResource.forEach(function(jsResource) {
                        var resource = new _this.omidSessionClient.VerificationScriptResource(_this.isDebugMode ? './omid-validation-verification-script-v1.js' : jsResource.uri, _this.isDebugMode ? 'dummyVendor' : verification.vendor, _this.isDebugMode ? JsonUtils.stringify({
                            k: 'v'
                        }) : verification.verificationParameters, accessMode);
                        resources.push(resource);
                    });
                });
                if (resources.length === 0) {
                    this.logger.verbose('No allowed verification script resources available, unable to create ad session context');
                    return;
                }
                var context = new this.omidSessionClient.Context(this.partner, resources, this.contentUrl);
                context.setServiceWindow(this.openMeasurementServiceWindow);
                this.context.set(adId, context);
                this.logger.verbose("Ad session context created for ad: ".concat(adId));
            }
        },
        {
            key: "addOpenMeasurementServiceScriptTag",
            value: function addOpenMeasurementServiceScriptTag() {
                var serviceScript = './omweb-v1.js';
                this.serviceScriptTag = document.createElement('script');
                this.serviceScriptTag.async = false;
                this.serviceScriptTag.src = serviceScript;
                document.body.appendChild(this.serviceScriptTag);
            }
        },
        {
            key: "blockEventsIfNoAdSessionAvailable",
            value: function blockEventsIfNoAdSessionAvailable() {
                if (!this.adEvents || !this.mediaEvents) {
                    return true;
                }
                return false;
            }
        }
    ]);
    return OpenMeasurementAddon;
}(ReportingAddon);

//# sourceMappingURL=open-measurement-addon.js.map